<template>
    <vs-col vs-w="12" v-if="is_edvisor">
        <div class="vs-row" style="padding-top: 5px;">
            <vs-col vs-w="1" style="margin-left: 20px;">
                <feather-icon
                    icon="ArrowLeftIcon"
                    @click="nazad()"
                    class="cursor-pointer mr-4"
                    svg-classes="w-9 h-9"
                ></feather-icon>
            </vs-col>
            <vs-col vs-w="10">
                        <span class="text-primary cursor-pointer" @click="nazad()" style="line-height: 24px;font-size:15px;margin-left: 5px;font-weight: 600;">
                            {{ full_name }}
                        </span>
            </vs-col>
        </div>
    </vs-col>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "Nazad",
    computed:{
        ...mapGetters({
            GET_STUDENT:'regis_discepline/GET_STUDENT',
        }),
        is_edvisor(){
            return this.$store.state.user.user.role.is_supervisor
        },
        full_name(){
            return this.GET_STUDENT.name_initial
        },
    },
    methods:{
        nazad(){
            this.$router.push({name:'applications_review_in_isc_profile',query:{...this.$route.query}})
        },
    }
};
</script>

<style scoped>

</style>
